@if (bonusStatus$ | async; as bonusStatus) {
  <div class="wrapper">
    <div class="block">
      <div class="title">
        <div>{{ bonusStatus.message }}</div>

        @if (bonusStatus.tooltipMessage) {
          <div class="custom-tooltip-container" (sdClickOutside)="closeTooltip()" (click)="toggleTooltip()">
            <div class="tooltip-icon">?</div>

            @if ((isTooltipOpen$ | async) || (isDesktopLgUp$ | async)) {
              <div class="custom-tooltip">
                <div class="tooltip-content" [innerHTML]="bonusStatus.tooltipMessage"></div>
                <div class="tooltip-arrow"></div>
              </div>
            }
          </div>
        }
      </div>
      <div class="scale-container">
        <div
          class="scale"
          [class.scale-active]="bonusStatus.loyaltyAmount.value > 0"
          [style.width.%]="progressWidth > 1 ? progressWidth : 1"
        ></div>
        <span class="scale-text">{{ bonusStatus.loyaltyAmount.formattedValue }}</span>
      </div>

      <div class="interval">{{ bonusStatus.intervalMessage }}</div>
    </div>

    <div class="levels-wrapper" id="level">
      <div class="levels">
        @for (level of bonusStatus.levels; track level.name) {
          <div class="level" [id]="level.isActive ? 'scrollId' : ''" [class.active]="level.isActive">
            <div class="title">
              <div class="name">{{ level.name }}</div>

              @if (level.isActive) {
                <div><sd-bonus-widget [amount]="bonusStatus.bonusAmountInfo?.value"></sd-bonus-widget></div>
              }
            </div>
            <div class="description" [innerHTML]="level.description"></div>
          </div>
        }
      </div>
    </div>
  </div>
}
